import React, { useEffect, useState } from 'react'
import { Chart, registerables } from "chart.js";
import { Doughnut, Pie } from "react-chartjs-2";

Chart.register(...registerables);

const InstructorChart = ({courses}) => {

    const [currChart, setCurrChart] = useState("students");

    const updateCourseData = () =>{
        const courseData = courses.filter((course)=> course.totalStudentsEnrolled !== 0);
        return courseData;
    }
    const [filteredCourses, setFilteredCourses] = useState(updateCourseData());

    // generate random color
    const generateRandomColors = (numColors) => {
        const colors = [];
        for (let i = 0; i < numColors; i++) {
            const color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
            colors.push(color);
        }
        return colors;
    }

    // data for display student information
    const chartDataStudents = {
        labels: filteredCourses.map((course)=> course.courseName),
        datasets: [
            {
                data: filteredCourses.map((course) => course.totalStudentsEnrolled),
                backgroundColor: generateRandomColors(filteredCourses.length),
            }
        ]
    }
    
    // data for display income information
    const chartIncomeData = {
        labels: filteredCourses.map((course)=> course.courseName),
        datasets: [
            {
                data: filteredCourses.map((course) => course.totalAmountGenerated),
                backgroundColor: generateRandomColors(filteredCourses.length),
            }
        ]
    }

    // options
    const options = {
        maintainAspectRatio: false,
    };


    return (
        <div className='flex flex-1 flex-col gap-y-4 rounded-md bg-richblack-800 p-6'>
            <p className="text-lg font-bold text-richblack-5">Visualize</p>
            <div className="space-x-4 font-semibold">
                {/* button to switch student chart */}
                <button onClick={() => setCurrChart("students")}
                    className={`rounded-sm p-1 px-3 transition-all duration-200 
                    ${currChart === "students" ? "bg-richblack-700 text-yellow-50" : "text-yellow-400"}`}
                >
                    Students
                </button>
                {/* Button to switch to the "income" chart */}
                <button onClick={() => setCurrChart("income")}
                    className={`rounded-sm p-1 px-3 transition-all duration-200 
                    ${ currChart === "income" ? "bg-richblack-700 text-yellow-50" : "text-yellow-400" }`}
                >
                    Income
                </button>
            </div>
            <div className="relative mx-auto aspect-square h-full w-full">
                {/* render charts */}
                {
                    currChart === "students" ? (
                        <Doughnut data={chartDataStudents} options={options}/>
                    ) : (
                        <Pie data={chartIncomeData} options={options}/>
                    )
                }
            </div>
        </div>
    )
}

export default InstructorChart
